import combine from './combine/combine';

const feeds = {
    'clients.feeds.general': 'General',
    'clients.feeds.add': 'Add feed',
    'clients.feeds.edit': 'Edit feed',

    'clients.feeds': 'Feeds',
    'clients.feeds.name': 'Name',
    'clients.feeds.type': 'Type',
    'clients.feeds.layout': 'Layout',
    'clients.feeds.host': 'Host',
    'clients.feeds.host_extra': 'Extra host',
    'clients.feeds.authentication_required': 'Authentication required',
    'clients.feeds.authentication_user': 'User name',
    'clients.feeds.authentication_password': 'Password',
    'clients.feeds.stock_required': 'Only when in stock',

    'clients.feeds.ftp_settings': 'FTP settings',
    'clients.feeds.path': 'Server path',
    'clients.feeds.file_name': 'File name of feed',

    'clients.feeds.ftp_images_settings': 'Images settings',
    'clients.feeds.ftp_download_images': 'Download images from FTP',

    'clients.feeds.file_upload_settings': 'File upload settings',
    'clients.feeds.choose_file': 'Choose file',
    'clients.feeds.choose_extra_file': 'Choose extra file (optional)',

    'clients.feeds.xml_settings': 'XML settings',
    'clients.feeds.product_node_name': 'Name of product node',

    'clients.feeds.csv_settings': 'CSV settings',
    'clients.feeds.seperator': 'Separator',
    'clients.feeds.word_seperator': 'Separator words',
    'clients.feeds.rows_ignore': 'Ignore X number of rows',
    'clients.feeds.first_row_names': 'The first row contains column names',

    'clients.feeds.settings': 'Feed settings',
    'clients.feeds.notation': 'Price decimal delimiter',

    ...combine,
};

export default feeds;
